module.exports = __webpack_public_path__ + "img/play.70450ae5.svg";